import _ from 'lodash';
import { Form, Query } from '@jgile/laravel-vue';

export default {
    props: {
        report: {
            type: Object,
            default: null,
        },
        reportTypes: {
            required: true,
            type: Object,
        },
    },
    data() {
        return {
            reportType: null,
            form: new Form({
                name: null,
                email: null,
            }),
            query: new Query({
                perPage: 25,
                type: null,
                fields: [],
                filters: {
                    run_date: null,
                },
            }),
            modal: {
                url: null,
                title: null,
                columns: [],
                query: {
                    perPage: 10,
                    type: null,
                    fields: [],
                    filters: {
                        run_date: null,
                    },
                },
            },
            modalKey: 1,
            openTableModal: false,
        };
    },
    created() {
        this.query.fromUrl();

        if (this.report) {
            this.form.name = this.report.name;
            this.query.set(_.pick(this.report, ['type', 'fields', 'filters']));
        }

        if (this.query.type) {
            this.updateType(this.query.type, false);
        }

        this.$watch('query.type', this.updateType);
    },
    computed: {
        columns() {
            return _.pick(_.get(this.reportType, 'fields'), _.get(this, 'query.fields', []));
        },
        filters() {
            return _.pickBy(this.columns, function (column) {
                return column.filters;
            });
        },
        haveFilters() {
            return !_.isEmpty(this.filters);
        },
        dateShortcuts() {
            let shortcuts = [];
            shortcuts.push({
                label: 'Current Month',
                date: [moment().startOf('month'), moment().endOf('month')],
            });
            shortcuts.push({
                label: 'Previous Month',
                date: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
            });
            shortcuts.push({
                label: 'Last 6 Months',
                date: [moment(), moment().subtract(6, 'month')],
            });
            shortcuts.push({
                label: 'Last 12 Months',
                date: [moment(), moment().subtract(12, 'month')],
            });
            if (_.has(this.spark, 'currentSchedule.start_date') && _.has(this.spark, 'currentSchedule.end_date')) {
                shortcuts.push({
                    label: 'Current Season',
                    date: [this.spark.currentSchedule.start_date, Spark.currentSchedule.end_date],
                });
                shortcuts.push({
                    label: 'Previous Season',
                    date: [
                        moment(this.spark.currentSchedule.start_date).subtract(1, 'year'),
                        moment(Spark.currentSchedule.end_date).subtract(1, 'year'),
                    ],
                });
            }
            shortcuts.push({
                label: 'Current Calendar Year',
                date: [moment().startOf('year'), moment().endOf('year')],
            });
            shortcuts.push({
                label: 'Previous Calendar Year',
                date: [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')],
            });

            return shortcuts;
        },
    },
    methods: {
        save() {
            this.form.type = this.query.type;
            this.form.fields = this.query.fields;
            this.form.filters = this.query.filters;

            if (this.report) {
                Spark.put(`/api/reports/${this.report.id}`, this.form).then(() => {
                    $('#modalSave').modal('hide');
                });
            } else {
                Spark.post('/api/reports', this.form).then(() => {
                    $('#modalSave').modal('hide');
                });
            }
        },
        share() {
            const self = this;
            this.$messenger.loading('#modalShare');
            this.query.post('/api/share/reports', this.form).then(() => {
                self.$messenger.loaded('#modalShare');
                $('#modalShare').modal('hide');
            });
        },
        shareReport() {
            $('#modalShare').modal('show');
        },
        exportReport() {
            window.location = this.query.url('/download/reports');
        },
        openSave() {
            $('#modalSave').modal('show');
        },
        openModal(modal) {
            this.openTableModal = false;
            this.modalKey++;
            this.$nextTick(() => {
                this.$set(this.modal, 'query', modal.query);
                this.$set(this.modal, 'title', modal.title);
                this.$set(this.modal, 'columns', modal.columns);
                this.$nextTick(() => {
                    this.openTableModal = true;
                });
            });
        },
        updateType(type, reset = true) {
            if (reset) {
                this.query.set('fields', []);
                this.query.set('filters', {});
            }

            Vue.set(this, 'reportType', _.get(this.reportTypes, type));

            this.query.set('fields', _.merge(this.query.fields, Object.keys(_.get(this.reportType, 'required_fields', {}))));

            this.updateFilters();
        },
        updateFilters() {
            if (!this.reportType) return;

            const self = this;
            _.each(this.reportType.fields, (field) => {
                _.each(field.filters, (filter) => {
                    if (!_.has(self.query.filters, filter.slug)) {
                        self.$set(self.query.filters, filter.slug, []);
                    }
                });
            });
        },
    },
    watch: {
        query: {
            deep: true,
            handler() {
                this.query.pushHistory();
            },
        },
    },
};
